import { IParticipant } from "../models/Chat";

export function getInitialsFromName(name: string): string {
  const initials = name
    ?.split(" ")
    .slice(0, 2)
    .map((word) => word.charAt(0))
    .join("");

  return initials;
}

export function getParticipantNames(
  participants: IParticipant[],
  selfId: string
) {
  return participants
    .filter((p) => p.id !== selfId)
    .map((p) => p.firstName + " " + p.lastName)
    .join(" ");
}

export function uppercaseFirstLetter(str: string) {
  if (typeof str !== "string") return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function toMessageText(
  detail: unknown,
  fallback = "Something went wrong"
): string {
  if (typeof detail === "string") return detail || fallback;

  if (
    Array.isArray(detail) &&
    detail.length > 0 &&
    detail.every((item) => typeof item === "string")
  ) {
    return detail.join(", ");
  }

  if (
    detail &&
    typeof detail === "object" &&
    typeof (detail as { message?: unknown }).message === "string"
  ) {
    return (detail as { message: string }).message;
  }

  return fallback;
}

export function systemName(str: string) {
  return str?.toUpperCase().replaceAll(" ", "_").replaceAll("-", "_");
}
